export default {
    product: '',
    range: [0, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48],
    fractional: {
        0: '0/8', 0.125: '1/8', 0.25: '1/4', 0.375: '3/8', 0.5: '1/2', 0.625: '5/8', 0.75: '3/4', 0.875: '7/8'
    },
    shelf_depth:0,
    shelf_width:0,
    diameter:'',
    finish:"",
    t1: 400,
    t2:650,
    original_price:0,
    minimum_price:0,
    qty:0,
    depth_display:0,
    width_display:0,
    loader:false
}